import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const UnsavedChangesAlert = ({ hasPermission = true }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Alert type="warning">
        {hasPermission ? t('Cambios sin guardar') : t('No tienes permisos para guardar los cambios')}
      </Alert>
    </Styles.Container>
  )
}

export default UnsavedChangesAlert
